// TicketList.jsx
import React, {useEffect} from 'react';
import TicketCard from './TicketCard';


const TicketList = ({ tickets, quantities, updateQuantity, isLoading, vehicleCapacity, vehicleCount, removeTicket, ticketType, isScheduled }) => {
  if (isLoading) {
    return (
      <div id="tickets-container" className="mt-8">
        <div className="text-center py-8">Loading tickets...</div>
      </div>
    );
  }

  if (!tickets || tickets.length === 0) {
    return null;
  }

  return (
    <div id="tickets-container" className="mt-8">
      <div id="general_tickets_list" className="grid gap-4">
        {tickets.map((ticket, index) => (
          <TicketCard
            key={ticket.id}
            ticket={ticket}
            quantity={quantities[ticket.id] || 0}
            updateQuantity={(change) => updateQuantity(ticket.id, change)}
            colorIndex={index % 3}
            vehicleCapacity={vehicleCapacity}
            vehicleCount={vehicleCount}
            removeTicket={removeTicket}
            isScheduled={isScheduled}
            theme={ticketType.currentTheme}
            ticketType={ticketType}
          />
        ))}
      </div>
    </div>
  );
};

export default TicketList;
